<app-navbar
  [headerText]="'Müştərilər'"
  [buttons]="navButtons"
  [dataLoading]="_customersService.dataLoading()"
></app-navbar>

<div class="container-fluid px-3">
  <div class="row mt-6">
    <div id="targetTable" class="col-md-6" style="position: relative">
      <div class="input-group">
        <div
          class="input-group-text"
          style="
            background-color: var(--primary-background);
            color: white;
            padding-inline: 20px;
            font-family: 'Mulish';
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
            cursor: pointer;
          "
          (click)="searchInput.focus()"
        >
          <span class="material-symbols-outlined"> search </span>
        </div>
        <input
          #searchInput
          type="text"
          class="form-control"
          (keyup)="applyFilter(searchInput.value)"
          (search)="applyFilter(searchInput.value)"
          (keyup.escape)="searchInput.value = ''; applyFilter('')"
          placeholder="Axtar"
        />
        @if (searchInput.value.length > 0) {
        <div
          class="input-group-append d-flex align-items-center justify-content-center"
          style="width: 50px; cursor: pointer"
          (click)="searchInput.value = ''; applyFilter('')"
        >
          <div class="input-group-text">
            <span class="material-symbols-outlined"> close </span>
          </div>
        </div>
        } @else {
        <div class="input-group-append d-flex" style="position: relative">
          <div
            matTooltip="Filter"
            matTooltipClass="line-broken-tooltip roundedTooltip"
            matTooltipPosition="right"
            style="cursor: pointer"
            class="input-group-text"
            (click)="showFilterOptions = !showFilterOptions"
          >
            <span class="material-symbols-outlined"> filter_alt </span>
            @if (customerGroupCategoryIds.length>0) {
            <span
              style="
                position: absolute;
                top: -5px;
                right: -5px;
                background: #2f4e6d;
                border-radius: 8px;
                padding: 0px 3px;
                color: white;
                width: 20px;
                font-size: 10px;
              "
              >{{ customerGroupCategoryIds.length }}</span
            >
            }
          </div>
        </div>
        }
      </div>

      <div
        class="overlay"
        style="
          position: fixed;
          top: 0;
          left: 0;
          background-color: rgba(0, 0, 0, 0.073);
          width: 100%;
          height: 100%;
          z-index: 1000;
        "
        *ngIf="showFilterOptions"
        (click)="showFilterOptions = false"
      ></div>
      <section
        class="filterTable"
        style="z-index: 1001; font-family: Mulish"
        *ngIf="showFilterOptions"
        [@slideInOut]="showFilterOptions ? 'in' : 'out'"
      >
        <div
          class="px-3 py-1"
          style="
            background-color: #0000000a;
            display: flex;
            font-family: 'Mulish';
            font-weight: 600;
            font-size: 18px;
          "
        >
          <span style="padding-left: 23px">Filter</span>
        </div>
        @for (item of customerGroups; track item.id) {
        <div
          class="d-flex gap-2 align-items-center cardHover px-3 py-2"
          (click)="changeFilter(item)"
          style="cursor: pointer; white-space: nowrap"
        >
          <div class="box">
            @if (item.filter) {
            <mat-icon
              style="
                color: var(--primary-background);
                font-size: 20px;
                line-height: 25px;
              "
              >check</mat-icon
            >
            } @if (item.unfilter) {
            <mat-icon style="color: red; font-size: 20px; line-height: 25px"
              >close</mat-icon
            >
            }
          </div>
          <span class="unselectable">{{ item.name }}</span>
        </div>
        }
        <div class="px-3 py-2" style="background-color: #0000000a">
          <button
            class="btn btnDelete w-100"
            style="
              padding: 4px !important;
              display: flex;
              justify-content: center;
              align-items: center;
              gap: 5px;
              min-width: 6rem;
            "
            (click)="clearFilterSelections()"
          >
            <span class="material-symbols-outlined"> remove_selection </span
            >Təmizlə
          </button>
          <button
            class="btn btnDelete w-100"
            style="
              padding: 4px !important;
              display: flex;
              justify-content: center;
              align-items: center;
              gap: 5px;
              min-width: 6rem;
            "
            (click)="showFilterOptions = false"
          >
            <span class="material-symbols-outlined"> close </span> Bağla
          </button>
        </div>
      </section>
    </div>
    <div class="col-md-6 mt-smm-6">
      <mat-chip-listbox aria-label="Customer Types">
        <mat-chip-option
          selected
          (click)="setChipSelected($event.target.innerText)"
          >Tərəf-Müqabillər</mat-chip-option
        >
        <mat-chip-option (click)="setChipSelected('Debitorlar')"
          >Debitorlar @if(_customersService.sumDebit != 0 ) {
          <span class="balanceSums">{{
            _customersService.sumDebit | number : "1.0-0" | commaToSpace
          }}</span>
          <span
            class="manat"
            style="font-size: 10px !important; text-align: center"
            >₼</span
          >}</mat-chip-option
        >
        <mat-chip-option (click)="setChipSelected('Kreditorlar')"
          >Kreditorlar @if(_customersService.sumKredit != 0 ) {
          <span class="balanceSums">{{
            (-_customersService.sumKredit | number : "1.0-0" | commaToSpace) ||
              0
          }}</span>
          <span
            class="manat"
            style="font-size: 10px !important; text-align: center"
            >₼</span
          >
          }</mat-chip-option
        >
      </mat-chip-listbox>
      <!-- <div class="summary">
        <span>Alınan {{ _bankService.totalIn | number }} <span class="manat">₼</span></span>
        <span>Ödənən {{ _bankService.totalOut | number }} <span class="manat">₼</span></span>
        <span>Fərq {{ _bankService.totalIn - _bankService.totalOut | number }} <span class="manat">₼</span></span>
      </div> -->
    </div>

    <div id="myGrid">
      <ag-grid-angular
        style="
          width: 100%;
          border-radius: 6px;
          overflow: hidden;
          margin-top: 1rem;
        "
        class="ag-theme-alpine customersTable ag-table"
        [rowData]="agGridData$ | async"
        [columnDefs]="columnDefs"
        [localeText]="_dataService.agGridLocale"
        (gridReady)="onGridReady($event)"
        (rowClicked)="_customersService.customerDialog($event.data)"
        [cacheQuickFilter]="true"
        [isExternalFilterPresent]="isExternalFilterPresent"
        [doesExternalFilterPass]="doesExternalFilterPass"
      >
      </ag-grid-angular>
    </div>
  </div>
</div>
